import * as React from "react";
import { AdContext } from "../context/AdContext";
import { dateFormat } from "./commonComponents";

interface Group {
  id: string;
  displayName: string;
  description: string;
  createdDateTime: string;
}

const Card = ({ group }: { group: Group }) => {
  const { navigateToGroup } = React.useContext(AdContext);

  return (
    <div className="adgc" onClick={() => navigateToGroup(group)}>
      <div className="adgc-body">
        <div className="adgc-1">
          <div className="adgc-name">{group.displayName}</div>
        </div>
        <div className="adgc-description">
          <abbr style={{ textDecoration: "none" }} title={group.description}>
            {group.description || "No description available"}
          </abbr>
        </div>
      </div>
      <div className="adgc-footer">
        <div className="adgc-2">
          <div className="adgc-m">Created on</div>
          <div className="adgc-resources">
            {dateFormat(group.createdDateTime) || "—"}
          </div>
        </div>
        <button
          className="view-group-btn"
          style={{
            background: "var(--accent-dim)",
            color: "var(--accent)",
            border: "1px solid rgba(59,130,246,0.25)",
            borderRadius: 6,
            padding: "5px 14px",
            fontWeight: 600,
            fontSize: 12,
            cursor: "pointer",
            transition: "background 0.15s, color 0.15s",
            letterSpacing: "0.1px",
          }}
          onClick={(e) => { e.stopPropagation(); navigateToGroup(group); }}
          onMouseEnter={(e) => { e.currentTarget.style.background = "var(--accent)"; e.currentTarget.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "var(--accent-dim)"; e.currentTarget.style.color = "var(--accent)"; }}
        >
          View →
        </button>
      </div>
    </div>
  );
};

export default Card;
